
// import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

import * as moment from "moment";
import * as React from "react";
import { ProfileTuneDropDownDto, ProfileTuneDropDownDtoImpl } from "src/com/sixdee/crbtportal/core/dto/dropdown/profiletunedropdowndto";
import { ProfileToneDto } from "src/com/sixdee/crbtportal/core/dto/profiletune/profiletonedto";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { ButtonComponent } from "../../../toolkit/button/buttoncomponent";
import { DropdownRowViewModelHandler, DropDownRowViewModelImpl } from "../../../toolkit/dropdownlist/dropdownrow/dropdownviewmodel";
import { LoaderComponent } from "../../../toolkit/loader/loadercomponent";
import { ProfileTuneSelectComponent } from "../../../toolkit/select/profiletuneselect/profiletuneselectcomponent";
import { UIComponentHandler } from "../../../toolkit/uicomponent";
import { UIComponentViewImpl } from "../../../toolkit/uicomponentview";
import { ConfirmRequestConfirmButtonCSSStyleImpl } from "../confirmrequest/confirmrequestconfirmbuttoncss";
import { LoaderWrapperComponent } from "../loaderwrappercomponent";
import { ToneDetailsPopupComponent, ToneOptionsType } from "../tonedetailspopup/tonedetailspopupcomponent";
import { ProfileToneComponentHandler, ProfileToneComponentProps, ProfileToneComponentState } from "./profiletonecomponent";
import { ProfileToneCSSStyle } from "./profiletonecss";

export class ProfileToneViewImpl extends UIComponentViewImpl<ProfileToneDto> implements DropdownRowViewModelHandler
{
    // private contactNumber:MsisdnFloatingTextComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;
    private selectComponent1: ProfileTuneSelectComponent | null;
    private selectComponent2 : ProfileTuneSelectComponent | null;
    private selectComponent3 : ProfileTuneSelectComponent | null;
    private listViewModel: DropDownRowViewModelImpl;
    private listViewModel2 :DropDownRowViewModelImpl;
    private listViewModel3:DropDownRowViewModelImpl;

    private dayValue: string = "0";
    private hourValue: string = "0";
    private mtsValue: string = "0";

    bindHandlers()
    {   
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onClosePopup = this.onClosePopup.bind(this);
       
    }
    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
        
       this.listViewModel = new DropDownRowViewModelImpl(false, context, this);
       this.listViewModel2 = new DropDownRowViewModelImpl(false, context, this);
       this.listViewModel3 = new DropDownRowViewModelImpl(false, context, this);
    //    this.listViewModel.setListDatas(this.getListOfDropDown());
    }

    draw(props: ProfileToneComponentProps, state: ProfileToneComponentState, cssStyle: ProfileToneCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        this.listViewModel.setListDatas(this.getListOfDaysDropDown());
        this.listViewModel2.setListDatas(this.getListOfTimeDropDown());
        this.listViewModel3.setListDatas(this.getListOfMinutesDropDown());
        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                {
                    this.getWebView(props, state, cssStyle)
                }

                  <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/> 
            </div>
        );
    }


    getWebView(props: ProfileToneComponentProps, state: ProfileToneComponentState, cssStyle: ProfileToneCSSStyle):JSX.Element
    {
        console.log("Is New User ^^^^^",state.isNewUser);
        return(
            <>
                 <ToneDetailsPopupComponent onCloseClick={props.closePopup} headerTitle={this.getContext().getResources().getString(Strings.profile_tunes)} toneDto={props.toneDto} context={props.context}/>

                    <div style={{width:"100%",display:"flex",height:'80px',justifyContent:"center"}}>
                           <div style={{width:"30%",height:"100%",marginRight:"10px"}}>
                            <label style={{width:"100%",textAlign:"left",height:"15px",lineHeight:"15px",fontSize:"18px",marginBottom:"5px"}}>
                                {this.getContext().getResources().getString(Strings.days)}
                            </label>
                           <ProfileTuneSelectComponent  listEmptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.no_groups_avaliable)}ref={(item)=>{this.selectComponent1 = item;}} listViewModel={this.listViewModel} placeholder={this.getUIProps().context.getResources().getString(Strings.days)} id={"#selecttime"} value={"0"} isRequired={true}  context={this.getUIProps().context} emptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.invalid_time_type)}/>

                           </div>
                           <div style={{width:"30%",height:"100%",marginRight:"10px"}}>
                           <label style={{width:"100%",textAlign:"left",height:"15px",lineHeight:"15px",fontSize:"18px",marginBottom:"5px"}}>
                                {this.getContext().getResources().getString(Strings.hours)}
                            </label>
                           <ProfileTuneSelectComponent listEmptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.no_groups_avaliable)}ref={(item)=>{this.selectComponent2 = item;}} listViewModel={this.listViewModel2} placeholder={this.getUIProps().context.getResources().getString(Strings.hours)} id={"#selecttime"} value={"0"} isRequired={true}  context={this.getUIProps().context} emptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.invalid_time_type)}/>

                           </div>
                           <div style={{width:"30%",height:"100%",}}>
                           <label style={{width:"100%",textAlign:"left",height:"15px",lineHeight:"15px",fontSize:"18px",marginBottom:"5px"}}>
                                {this.getContext().getResources().getString(Strings.minutes)}
                            </label>
                           <ProfileTuneSelectComponent listEmptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.no_groups_avaliable)}ref={(item)=>{this.selectComponent3 = item;}} listViewModel={this.listViewModel3} placeholder={this.getUIProps().context.getResources().getString(Strings.minutes)} id={"#selecttime"} value={"0"} isRequired={true}  context={this.getUIProps().context} emptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.invalid_time_type)}/>

                           </div>
                           
                    </div>
                  
                    {
                      <div style={cssStyle.getConfirmButtonCSSStyle()}>
                          <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getUserContext().getIsLoggedIn() ? props.context.getResources().getString(Strings.confirm) : props.context.getResources().getString(Strings.verify)}/>
                    </div>}   

                    <label>{this.getUIProps().context.getResources().getString(Strings.status_tune_confiemation)}</label>
                    
            </>
        );
    }
    getMobileView(props: ProfileToneComponentProps, state: ProfileToneComponentState, cssStyle: ProfileToneCSSStyle):JSX.Element
    {
        return(
            <>
                 <ToneDetailsPopupComponent onCloseClick={props.closePopup} headerTitle={props.toneOptionsType === ToneOptionsType.TONE ? props.context.getResources().getString(Strings.buytone) : props.context.getResources().getString(Strings.buy_playlist)} toneDto={props.toneDto} context={props.context}/>
               {/* <div style={cssStyle.getContentDivCSSStyle()}>
                    <label style={cssStyle.getContentLabel1CSSStyle()}>
                        {props.context.getResources().getString(Strings.get_your_loved_tune)}
                    </label>
                    <label style={cssStyle.getContentLabel2CSSStyle()}>
                        {props.context.getResources().getString(Strings.SDG_for_60_days)}
                    </label>
               </div>   
               <label style={cssStyle.getSubcriptionDivCSSStyle()}>
                {props.context.getResources().getString(Strings.Subscription_charges_of_2_SDG_for_30_days)}
               </label>  */}

                    <div style={{width:'100%',height:'50px',position:"relative",marginTop:'30px',paddingLeft:'25px',paddingRight:'25px'}}>
                            
                            <div style={{width:'100%',height:'20px',lineHeight:'20px',fontSize:'10px',color:'#898989' }}>
                                     <label style={{width:'50%',height:'100%',lineHeight:'100%',textAlign:'left'}}>
                                         {this.getContext().getResources().getString(Strings.tune_charge)}
                                     </label>
                                     <label style={{width:'50%',height:'100%',lineHeight:'100%',textAlign:'right'}}>
                                         {this.getContext().getResources().getString(Strings.absolute_validity)}
                                     </label>
                            </div> 
                            <div style={{width:'100%',height:'20px',lineHeight:'20px',fontSize:'12px',color:'#33495F',fontWeight:900 }}>
                                     <label style={{width:'60%',height:'100%',lineHeight:'100%',textAlign:'left'}}>
                                         {state.price}
                                     </label>
                                     <label style={{width:'40%',height:'100%',lineHeight:'100%',textAlign:'right'}}>
                                         {props.toneDto.getExpirydate()}
                                     </label>
                            </div>
                    </div>
    
                    <div style={cssStyle.getConfirmButtonCSSStyle()}>
                          <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getUserContext().getIsLoggedIn() ? props.context.getResources().getString(Strings.confirm) : props.context.getResources().getString(Strings.verify)}/>
                    </div>
                    
                    {state.isNewUser &&
                          <div id="subscription-pack-price">
                                <label>{this.getContext().getResources().getString(Strings.subscription_pack_price_details)+this.getSubscriptionPackDetails()}</label>
                    </div>}
                   
            </>
        );
    }
    onRowSelected(dropDownDto: ProfileTuneDropDownDto): void 
    {

        if(dropDownDto.getType() === "Day")
        {
            this.dayValue = dropDownDto.getTitle();
            this.selectComponent1 !== null
            && this.selectComponent1.onOptionSelected(dropDownDto.getId(), dropDownDto.getTitle());
        }
        else if(dropDownDto.getType() === "Time"){
            this.hourValue = dropDownDto.getTitle();
            this.selectComponent2 !== null
        && this.selectComponent2.onOptionSelected(dropDownDto.getId(), dropDownDto.getTitle());
        }
        else {
            this.mtsValue = dropDownDto.getTitle();
            this.selectComponent3 !== null
            && this.selectComponent3.onOptionSelected(dropDownDto.getId(), dropDownDto.getTitle());
        }
      
        
    }
    showLoader()
    {
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    
    onClosePopup():void
    {
        (this.getUIProps() as ProfileToneComponentProps).closePopup();
    }

    private onConfirmClick()
    {



        let startDate:string = moment().format("YYYY-MM-DD");
        let startTime:string = moment().format("HH:mm:ss");
        
        let endDate:string = moment().add(this.dayValue, "d").add(this.hourValue, "hours").add(this.mtsValue, "minutes").format("YYYY-MM-DD");
        let endTime:string = moment().add(this.dayValue, "d").add(this.hourValue, "hours").add(this.mtsValue, "minutes").format("HH:mm:ss");

        if(this.dayValue === "0" && this.hourValue === "0" && this.mtsValue === "0"){
            this.selectComponent3?.setErrorMessage(this.getContext().getResources().getString(Strings.empty_profile_tune));
        }
        else
        {
            (this.getUIComponentHandler() as ProfileToneComponentHandler).onConfirmClick(startDate, startTime, endDate, endTime);
        }
    }

    private getSubscriptionPackDetails():string{

      var priceDetails = this.getContext().getConfigurationSettings().getPropertyBasedOnLanguage("SUBSCRIPTION_PLAN").replace("CRBT,"," ");
      console.log("Subscription price details", priceDetails);
      return priceDetails;
    }
    private getListOfDaysDropDown()
    {   
            
            let dropDown1 = new ProfileTuneDropDownDtoImpl();
            dropDown1.setId("0");
            dropDown1.setIconName("");
            dropDown1.setTitle("0");
            dropDown1.setType("Day");

            let dropDown2 = new ProfileTuneDropDownDtoImpl();
            dropDown2.setId("1");
            dropDown2.setIconName("");
            dropDown2.setTitle("1");
            dropDown2.setType("Day");

            let dropDown3 = new ProfileTuneDropDownDtoImpl();
            dropDown3.setId("2");
            dropDown3.setIconName("");
            dropDown3.setTitle("2");
            dropDown3.setType("Day");

            let dropDown4 = new ProfileTuneDropDownDtoImpl();
            dropDown4.setId("3");
            dropDown4.setIconName("");
            dropDown4.setTitle("3");
            dropDown4.setType("Day");

            let dropDown5 = new ProfileTuneDropDownDtoImpl();
            dropDown5.setId("4");
            dropDown5.setIconName("");
            dropDown5.setTitle("4");
            dropDown5.setType("Day");

            let dropDown6 = new ProfileTuneDropDownDtoImpl();
            dropDown6.setId("5");
            dropDown6.setIconName("");
            dropDown6.setTitle("5");
            dropDown6.setType("Day");

            let dropDown7 = new ProfileTuneDropDownDtoImpl();
            dropDown7.setId("6");
            dropDown7.setIconName("");
            dropDown7.setTitle("6");
            dropDown7.setType("Day");

            let dropDown8 = new ProfileTuneDropDownDtoImpl();
            dropDown8.setId("7");
            dropDown8.setIconName("");
            dropDown8.setTitle("7");
            dropDown8.setType("Day");

            return [dropDown1, dropDown2, dropDown3, dropDown4, dropDown5, dropDown6, dropDown7, dropDown8];


    }
    private getListOfTimeDropDown()
    {   

        const results = [];
        for (let index = 0; index < 25; index++) {
            let dropDown = new ProfileTuneDropDownDtoImpl();
            dropDown.setId(""+index);
            dropDown.setIconName("");
            dropDown.setTitle(""+index);
            dropDown.setType("Time");

            results.push(dropDown);
        }
            
            return results;


    }
    private getListOfMinutesDropDown()
    {   
        const results = [];
        for (let index = 0; index < 61; index++) {
            let dropDown = new ProfileTuneDropDownDtoImpl();
            dropDown.setId(""+index);
            dropDown.setIconName("");
            dropDown.setTitle(""+index);
            dropDown.setType("Minutes");

            results.push(dropDown);
        }
            
            return results;


    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/profiletone/profiletoneview.tsx